import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import MovieCard from '../components/MovieCard';
import Pagination from '../components/Pagination';
import GenreFilter from '../components/GenreFilter';
import {discoverTvShows, getTvShowGenres  } from '../services/tmdbApi';

const Grid = styled.div`
 display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
  }
`;

const CardWrapper = styled.div`
  width: 200px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

const FilterWrapper = styled.div`
  margin-bottom: 20px;
  margin-left: 10px
`;

const SectionTitle = styled.h2`
   font-size: 20px;
   margin-left: 10px;
  margin-bottom: 15px;
  color: ${props => props.theme.text};
  display: flex;
  align-items: center;
  
  &:before {
    content: '';
    display: inline-block;
    width: 7px;
    height: 23px;
    background-color: ${props => props.theme.primary};
    margin-right: 10px;
    border-radius: 32px;

  }
  
  @media (min-width: 768px) {
    font-size: 26px;
    margin-bottom: 20px;
    
    &:before {
      height: 28px;
    }
  }
`;


function TvShows() {
  const [tvShows, setTvShows] = useState([]);
  const [genres, setGenres] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState('all');
  const [selectedSort, setSelectedSort] = useState('popularity.desc');
  const [selectedYear, setSelectedYear] = useState('all');
  const [selectedLanguage, setSelectedLanguage] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchTvShows = async () => {
      try {
        const response = await discoverTvShows(currentPage, {
          with_genres: selectedGenre !== 'all' ? selectedGenre : '',
          sort_by: selectedSort,
          first_air_date_year: selectedYear !== 'all' ? selectedYear : '',
          with_original_language: selectedLanguage !== 'all' ? selectedLanguage : '',
        });
        setTvShows(response.data.results);
        setTotalPages(response.data.total_pages);
      } catch (error) {
        console.error('Error fetching TV shows:', error);
      }
    };

    fetchTvShows();
  }, [currentPage, selectedGenre, selectedSort, selectedYear, selectedLanguage]);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        const response = await getTvShowGenres();
        setGenres(response.data.genres);
      } catch (error) {
        console.error('Error fetching TV show genres:', error);
      }
    };

    fetchGenres();
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleGenreSelect = (genreId) => {
    setSelectedGenre(genreId);
    setCurrentPage(1);
  };

  const handleSortSelect = (sort) => {
    setSelectedSort(sort);
    setCurrentPage(1);
  };

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setCurrentPage(1);
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);
    setCurrentPage(1);
  };

  return (
    <div>
      <SectionTitle>Popular TV Shows</SectionTitle>
      <FilterWrapper>
        <GenreFilter
          genres={genres}
          selectedGenre={selectedGenre}
          onGenreSelect={handleGenreSelect}
          selectedSort={selectedSort}
          onSortSelect={handleSortSelect}
          selectedYear={selectedYear}
          onYearSelect={handleYearSelect}
          selectedLanguage={selectedLanguage}
          onLanguageSelect={handleLanguageSelect}
        />
      </FilterWrapper>
      <Grid>
        {tvShows.map((show) => (
        <CardWrapper key={show.id}>
          <MovieCard
            key={show.id}
            movie={{
              ...show,
              title: show.name,
              release_date: show.first_air_date,
              media_type: 'tv'
            }}
            genres={genres}
          />
          </CardWrapper>
        ))}
      </Grid>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default TvShows;